import { CloudAccount } from "./CloudAccount";
import { CloudCustomer } from "./CloudCustomer";
import { CloudEnvironment } from "./CloudEnvironment";
import { DevOpsActionAndParameter } from "./DevOpsActionAndParameter";

export class CreateDevOpsActionDialogData {

    selectedCutomerId?: string;
    selectedAccountId?: string;
    selectedEnvironmentId?: string;
    selectedRegion?: string;
    selectedDevOpsActionAndParameter?: DevOpsActionAndParameter;

    cloudCutomers?: CloudCustomer[];
    cloudAccounts?: CloudAccount[];
    cloudEnvironments?: CloudEnvironment[];
    supportedRegions?: string[];
    devOpsActionsAndParameters?: DevOpsActionAndParameter[];
}